import type {
  PinChangeOrigin,
  PinChangeReason
} from '@/Network/Types/Responses/PinSuggestionResponses'
import type { HealthUnitType } from '../../unitType'

/** `form`: o pino volta ao formulário da unidade; `standalone`: salva direto pelo PATCH do pino. */
export type PinModalMode = 'form' | 'standalone'

export type PinStep = 1 | 2 | 3

/** Ponto de um check no mapa do passo 2 (aceito em verde, rejeitado em vermelho). */
export interface DoctorPoint {
  id: number | string
  lat: number
  lng: number
  color: string
  label: string
  accepted: boolean
}

/** O que o modal devolve ao confirmar — espelha `UpdateHealthUnitPinBody`/`HealthUnitPinMeta`. */
export interface PinConfirmPayload {
  latitude: number
  longitude: number
  reachRadius: number
  type: HealthUnitType
  origin: PinChangeOrigin
  reason: PinChangeReason | null
  reasonDetail: string
  radiusJustification: string
  confirmedOnBuilding: true
  suggestionId: number | null
}

/**
 * Abaixo disso a edição é ajuste fino (imprecisão do próprio pino), não uma
 * mudança de lugar — cobrar "motivo" aí só treinaria o usuário a escolher
 * qualquer opção para passar da tela.
 */
export const PIN_MOVE_THRESHOLD_M = 25
